<template>
  <v-container class="pa-0" fluid>
    <!-- Snackbar -->
    <SnackbarMessage ref="snackbar" />

    <!-- Layout paginado -->
    <PaginatedLayout :items="users" @update-page="updatePage" class="pb-15">
      <!-- Header -->
      <template v-slot:header>
        <DeltiaCard>
          <!-- Columna para el título -->
          <v-col cols="12" md="7" class="mb-6">
            <p class="display-1 font-weight-bold mb-0 pb-0">Empleados</p>
          </v-col>
          <!-- Columna para el botón de agregar usuarios -->
          <v-col cols="12" md="5" class="mb-6">
            <NewEmployee
              @new-user="onEmployeeCreated"
              @employee-error="onError"
            />
          </v-col>
        </DeltiaCard>
      </template>
      <!-- Sucursales -->
      <template v-slot:items>
        <!-- Pantalla de carga -->
        <LoadingLayout v-if="isLoading">
          <LinearLoading>
            Cargando empleados
          </LinearLoading>
        </LoadingLayout>
        <!-- Items -->
        <v-row v-else no-gutters v-for="item in users.docs" :key="item._id">
          <!-- Única columna para el usuario -->
          <v-col cols="12">
            <!-- Mostrar item para cada usuario -->
            <UserItem
              :userId="item._id"
              :type="item.user_type"
              :email="item.email"
              :date="item.created_at"
              :name="item.name"
              :phoneNumber="item.phone_number"
              @employee-error="onError"
            />
          </v-col>
        </v-row>
      </template>
    </PaginatedLayout>
  </v-container>
</template>

<script>
// Importar componentes
import PaginatedLayout from "@/layouts/PaginatedLayout";
import LinearLoading from "@/components/Loading/Linear";
import LoadingLayout from "@/layouts/LoadingLayout";
import UserItem from "@/components/users/UserItem";
import NewEmployee from "@/components/users/modals/NewEmployeeForm";
import DeltiaCard from "@/components/DeltiaCard";
import SnackbarMessage from "@/components/SnackbarMessage";

// Importar servicios
import UsersServices from "@/services/UsersServices";

// Importar getters
import { mapGetters } from "vuex";

export default {
  components: {
    LinearLoading,
    LoadingLayout,
    PaginatedLayout,
    NewEmployee,
    SnackbarMessage,
    UserItem,
    DeltiaCard
  },
  computed: {
    ...mapGetters(["getProfile"])
  },
  data: function() {
    return {
      users: { docs: [] },
      isLoading: true
    };
  },
  mounted: async function() {
    // Obtener usuarios
    await this.updatePage();
  },
  methods: {
    updatePage: async function(page = 1) {
      try {
        // Mostrar pantalla de carga
        this.isLoading = true;

        // Realizar petición
        this.users = await UsersServices.getUsersByBusiness(
          this.getProfile.business_id,
          page
        );

        // Ocultar pantalla de carga
        this.isLoading = false;
      } catch (err) {
        // Mostrar error
        this.onError(err.message);
      }
    },
    onEmployeeCreated: async function() {
      // Mostrar mensaje de éxito
      this.$refs.snackbar.showSuccessMessage("Usuario registrado con éxito");

      // Actualizar la página
      await this.updatePage();
    },
    onError: function(errorMessage) {
      // Mostrar error
      this.$refs.snackbar.showError(errorMessage);
    }
  }
};
</script>

<style scoped>
.text-hint {
  color: #9e9e9e;
}
</style>
